import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import ui from 'redux-ui';
import './InteractiveLayerContainer.css';
import InteractiveLayer from '../interactive-layer/InteractiveLayer';
import TextToImage from '../text-to-image/TextToImage';
import {
  MmToPx,
  showAlertModal,
  generatePreview,
} from './../../redux/helpers';
import { getTextWrapper } from './../../redux/helpers/texts';
import { changeTextProperty } from './../../redux/actions/entities/texts';


class InteractiveLayerContainer extends Component {
  constructor(args) {
    super(args);
    this.coverSize = 0;
    this.innerPageSize = 0;
    this.pageRatio = 1;
    this.dragRef = '';
    this.spineRef = '';
    this.InteractiveLayerContainer = '';
  }


  componentDidUpdate(prevProps) {
    const { coverSizes: currentCover } = this.props.bookproperties.cover;
    if (currentCover && 'bookproperties' in this.props) {
      this.innerPageSize = this.props.bookproperties.bookSizes.width;
      this.coverSize = currentCover.widthInPx;
    }

    /* const { ratio: prevratio } = prevProps.bookproperties.bookSizes;
    if (prevratio !== this.pageRatio) {
      this.props.dispatch(updateBookRatio(this.pageRatio));
    } */

    const { pageNumber, isOrder } = this.props;
    const { pageNumber: prevNumber } = prevProps;

    if ((pageNumber === 1 || pageNumber !== prevNumber) && isOrder) {
      const { pages } = this.props;
      const pagesLength = Object.keys(pages).length;

      const activePage = Object.values(pages).find(element => element.isActive);
      const nextPage = Object.values(pages).find(element => element.order === activePage.order + 1);
      if (nextPage) {
        const nextId = nextPage.id;
        generatePreview(this.props.dispatch, pageNumber - 1, pagesLength, nextId);
      } else {
        generatePreview(this.props.dispatch, pageNumber - 1, pagesLength, activePage.id);
      }
    }
  }


  getCoverMarginType = () => {
    const { bookproperties } = this.props;
    return bookproperties;
  }

  getActiveText = () => {
    const { text } = this.props;
    return Object.values(text).find(element => (element ? element.isActive : ''));
  }

  resizeMargin = () => {
    const container = this.InteractiveLayerContainer;
    const { photoCover } = this.props;

    if (container) {
      this.pageRatio = photoCover ? this.coverSize / container.clientWidth : this.innerPageSize / container.clientWidth;
    }
  }


  removeActiveTextClass = () => {
    const {
      id,
      text,
    } = this.getActiveText();
    const {
      title_notice,
      emptyTextInputAlert,
    } = this.props.lang;
    if (text === '') {
      return showAlertModal(title_notice, emptyTextInputAlert);
    }
    return this.props.dispatch(changeTextProperty(id, 'isActive', false));
  }

  render() {
    this.resizeMargin();
    const {
      ui,
      pageNumber,
      placeholders,
      spine,
      photoCover,
      backgroundColor,
      allowRender,
      lang,
      coverLayoutWidth,
      bookproperties,
      text,
      EditorLimit,
      backgroundImage,
      backgroundPlaceholders,
      datePlaceholders,
    } = this.props;

    const { marginType } = ui;
    const coverMargin = bookproperties.cover.margins;


    const bookMargin = bookproperties.dimensions.margin;
    const pageMargin = photoCover ? coverMargin : bookMargin;
    const bookId = bookproperties.calendarId;

    const marginSizes = {
      top: MmToPx(pageMargin.top) / this.pageRatio,
      left: MmToPx(pageMargin.left) / this.pageRatio,
      right: MmToPx(pageMargin.right) / this.pageRatio,
      bottom: MmToPx(pageMargin.bottom) / this.pageRatio,
    };

    // 10mm before margin
    const coverType = bookproperties.cover.type;
    const BeforeMarginLimit = MmToPx(10) / this.pageRatio;
    const TextWrapper = getTextWrapper(photoCover, marginSizes, EditorLimit, BeforeMarginLimit, this.pageRatio, coverType);

    const pageText = Object.values(text).filter(element => (element ? !element.isSpineText : ''));
    const activeText = this.getActiveText();

    return (
      <div className="InteractiveLayerContainer" ref={(layer) => { this.InteractiveLayerContainer = layer; }}>
        <InteractiveLayer
          spine={spine}
          pageNumber={pageNumber}
          placeholders={placeholders}
          backgroundPlaceholders={backgroundPlaceholders}
          datePlaceholders={datePlaceholders}
          isPhotoCover={photoCover}
          backgroundColor={backgroundColor}
          backgroundImage={backgroundImage}
          allowRender={allowRender}
          lang={lang}
          coverLayoutWidth={coverLayoutWidth}
          coverMargin={bookproperties.cover.margins}
          bookMargin={bookproperties.dimensions.margin}
          coverType={bookproperties.cover.type}
          context={bookproperties.context}
        />
        <div
          data-html2canvas-ignore="true"
          className={`margintype top ${marginType || ''}`}
          style={{
            height: marginSizes.top,
            left: 0,
            right: 0,
            top: 0,
          }}
        />
        <div
          data-html2canvas-ignore="true"
          className={`margintype left ${marginType || ''}`}
          style={{
            bottom: marginSizes.bottom,
            left: 0,
            top: marginSizes.top,
            width: marginSizes.left,
          }}
        />
        <div
          data-html2canvas-ignore="true"
          className={`margintype right ${marginType || ''}`}
          style={{
              bottom: marginSizes.bottom,
              right: 0,
              top: marginSizes.top,
              left: 'initial',
              width: marginSizes.right,
            }}
        />
        <div
          data-html2canvas-ignore="true"
          className={`margintype bottom ${marginType || ''}`}
          style={{
            bottom: 0,
            height: marginSizes.bottom,
            left: 0,
            top: 'initial',
            right: 0,
          }}
        />

        { activeText && <div className="text-overlay" onClick={this.removeActiveTextClass} /> }
        { TextWrapper.map((wrapper, index) => (
          <div
            ref={(dragRef) => { this.dragRef = dragRef; }}
            className="dragLimit"
            style={wrapper}
            key={`dragLimit-${index}`}
          >
            { Object.values(pageText).map(item => (

              <TextToImage
                key={item.id}
                id={item.id}
                text={item.text}
                images={item.images}
                style={item.positions}
                isActive={item.isActive}
                isOverflow={item.isOverflow}
                isMoveable={item.isMoveable}
                marginLimit={BeforeMarginLimit}
                pageRatio={this.pageRatio}
                dragWrapper={this.dragRef}
                spineRef={this.spineRef}
                isPhotoCover={photoCover}
                isSpineText={item.isSpineText}
                imageWidth={item.images ? item.images.thumbnail.width : 0}
                layerRef={this.InteractiveLayerContainer}
                bookId={bookId}
              />))
            }
          </div>
          )) }


      </div>
    );
  }
}

InteractiveLayerContainer.defaultProps = {
  pageNumber: 1,
  spine: {},
  photoCover: false,
  backgroundColor: '#fff',
  allowRender: false,
  lang: {},
  coverLayoutWidth: 1100,
  bookproperties: {},
  placeholders: [],
  text: [],
  EditorLimit: {},
  backgroundImage: '',
  datePlaceholders: [],
};

InteractiveLayerContainer.propTypes = {
  pageNumber: PropTypes.number,
  spine: PropTypes.object,
  photoCover: PropTypes.bool,
  backgroundColor: PropTypes.string,
  allowRender: PropTypes.bool,
  lang: PropTypes.object,
  coverLayoutWidth: PropTypes.number,
  bookproperties: PropTypes.object,
  placeholders: PropTypes.array,
  text: PropTypes.array,
  EditorLimit: PropTypes.object,
  backgroundImage: PropTypes.string,
  datePlaceholders: PropTypes.array,
};


InteractiveLayerContainer = ui({
  key: 'EditorToolsUI',
  state: { marginType: '' },
})(InteractiveLayerContainer);

export default connect(state => ({
  bookproperties: state.bookProperties,
  spineColor: state.entities.cover.spine.backgroundColor,
  isOrder: state.editorUI.isOrder,
}
))(InteractiveLayerContainer);



// WEBPACK FOOTER //
// ./src/components/interactive-layer-container/InteractiveLayerContainer.jsx